import { Input } from 'components/ui/input';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const CharacterDetails = ({
  openCharacterDetails,
}: {
  openCharacterDetails: boolean;
}) => {
  // to maintain background is not scrollable
  useEffect(() => {
    if (openCharacterDetails) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
    return () => document.body.classList.remove('overflow-hidden');
  }, [openCharacterDetails]);

  // to get hosts and guests information
  const { hosts, guests } = useSelector((state: RootState) => state.podcastGen);
  
  // Custom styles for the input fields
  const inputStyles = "border-[1px] border-[rgba(0,20,13,0.16)] rounded-[8px] bg-white focus:ring-0 h-12 px-4";

  return (
    <>
      <div className="w-full max-w-5xl h-auto overflow-y-auto">
        <div className="flex flex-col gap-4">
          {/* host details */}
          <div className="bg-[#ebebeb] rounded-lg px-8 py-8">
            <div className="flex flex-col gap-8">
              {/* heading */}
              <div>
                <h1 className="text-[32px] text-black font-semibold text-left">
                  Host details
                </h1>
              </div>
              {/* detail heading */}
              <div className="flex flex-col gap-2">
                <div className="grid grid-rows-1 grid-cols-4 grid-flow-row text-[#1C2024] gap-8">
                  <h2>Voice</h2>
                  <h2>Name</h2>
                  <h2>Age</h2>
                  <h2>Qualities</h2>
                </div>
                {hosts.map((host, index) => (
                  <div
                    className="grid grid-rows-1 grid-cols-4 gap-8"
                    key={index}
                  >
                    {/* mapping of inputs */}
                    <Input defaultValue={host?.voice_name || "Text"} disabled className={inputStyles} />
                    <Input defaultValue={host?.character_name || "Text"} disabled className={inputStyles} />
                    <Input defaultValue={host?.age || "Text"} disabled className={inputStyles} />
                    <Input defaultValue={host?.qualities?.length ? host.qualities.join(', ') : 'Text'} disabled className={inputStyles} />
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* guest details */}
          <div className="bg-[#ebebeb] rounded-lg px-8 py-8">
            <div className="flex flex-col gap-8">
              {/* heading */}
              <div>
                <h1 className="text-[32px] text-black font-semibold text-left">
                  Guest details
                </h1>
              </div>
              {/* detail heading */}
              <div className="flex flex-col gap-2">
                <div className="grid grid-rows-1 grid-cols-4 grid-flow-row text-[#1C2024] gap-8">
                  <h2>Voice</h2>
                  <h2>Name</h2>
                  <h2>Age</h2>
                  <h2>Tone</h2>
                </div>
                {/* container for inputs */}
                {guests.map((guest, index) => (
                  <div
                    className="grid grid-rows-1 grid-cols-4 gap-8"
                    key={index}
                  >
                    {/* mapping of inputs */}
                    <Input defaultValue={guest?.voice_name || "Text"} disabled className={inputStyles} />
                    <Input defaultValue={guest?.character_name || "Text"} disabled className={inputStyles} />
                    <Input defaultValue={guest?.age || "Text"} disabled className={inputStyles} />
                    <Input defaultValue={guest?.qualities?.length ? guest.qualities.join(', ') : 'Text'} disabled className={inputStyles} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CharacterDetails;
